
const average = array =>
    array.reduce((total, currentValue) => total + currentValue, 0) / array.length

const median = array => {
    if (array.length === 0) return 0

    array.sort((a, b) => a - b)

    const half = Math.floor(array.length / 2)

    if (array.length % 2) return array[half]
    return (array[half - 1] + array[half]) / 2.0
}

const standardDeviation = array => {
    const avg = average(array)

    const squareDiffs = array.map(function (value) {
        const diff = value - avg
        const sqrDiff = diff * diff
        return sqrDiff
    })

    const averageSquareDiff = average(squareDiffs)

    const stdDeviation = Math.sqrt(averageSquareDiff)
    return stdDeviation
}

const coefficientOfVariation = (array) => {
    const stdDeviation = standardDeviation(array)
    const media = median(array)

    return (stdDeviation / media) * 100;
}

const quantile = (array, q) => {
    const sorted = array.sort((a, b) => a - b);
    const pos = (sorted.length - 1) * q;
    const base = Math.floor(pos);
    const rest = pos - base;
    if (sorted[base + 1] !== undefined) {
      return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
    } else {
      return sorted[base];
    }
  };

export { average, coefficientOfVariation, median, standardDeviation, quantile }
